export default function Excel_Study_Plan() {
  return <div>Excel_Study_Plan</div>;
}
